module.exports = __webpack_public_path__ + "img/bus_black.9b19d70b.svg";